/**
 * Agregação client-side: ~1052 usinas eolicas → ~156 conjuntos.
 *
 * Reduce por `id_conjunto` numa unica passada. Para cada grupo:
 *   - `qtd_usinas` = numero de usinas no grupo
 *   - `potencia_total_mw` = soma das potencias (MW)
 *   - demais campos (cod_conjunto, ponto_de_conexao, label_conjunto, uf_*,
 *     subsistema_*, localizacao_epe) vem do PRIMEIRO item — todos invariantes
 *     dentro do mesmo conjunto por construcao do JOIN no backend (WINDX-024:
 *     windx_usinas_eolicas_service.py projeta c.label AS label_conjunto).
 *
 * Custo: O(n) onde n = numero de usinas. Medido localmente: ~0.6ms para
 * 1052 itens (R7 5800X, Chrome devtools). Memoizado pelo consumidor.
 *
 * Ordenacao final por `cod_conjunto` ascendente (locale pt-BR) — alinhada
 * com a ordem padrao dos selects de entidade do projeto. Ordenacao por
 * outras colunas e responsabilidade do componente Tabela.
 */
import { ConjuntoAgregado, UsinaEolicaDenormalizada } from 'helper/windx';

export default function agregarConjuntos(
  usinas: UsinaEolicaDenormalizada[],
): ConjuntoAgregado[] {
  const mapa = new Map<number, ConjuntoAgregado>();
  usinas.forEach((u) => {
    const existente = mapa.get(u.id_conjunto);
    if (existente) {
      existente.qtd_usinas += 1;
      existente.potencia_total_mw += u.potencia;
      return;
    }
    mapa.set(u.id_conjunto, {
      id: u.id_conjunto,
      cod_conjunto: u.cod_conjunto,
      // WINDX-024: ConjuntoAgregado.label = label_conjunto da usina
      // (mesma derivacao do BD; consistencia entre rotas).
      ponto_de_conexao: u.ponto_de_conexao,
      label: u.label_conjunto,
      uf_sigla: u.uf_sigla,
      uf_nome: u.uf_nome,
      subsistema_sm_sigla: u.subsistema_sm_sigla,
      subsistema_sh_sigla: u.subsistema_sh_sigla,
      localizacao_epe: u.localizacao_epe,
      qtd_usinas: 1,
      potencia_total_mw: u.potencia,
    });
  });
  // WINDX-024: ordenacao default por `label` (alinhada ao backend, que
  // ordena por c.label em /conjuntos/ e /usinas-eolicas/).
  return Array.from(mapa.values()).sort(
    (a, b) => a.label.localeCompare(b.label, 'pt-BR'),
  );
}
